import { TrendingDown, TrendingUp } from 'lucide-react'
import type { ReactNode } from 'react'
import { InspectionKpiCard } from '@/components/inspection-kpi-card'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { InspectionKind } from '@/hooks/use-personal-inspections-summary'
import { cn } from '@/lib/utils'

type KindConfig = Record<
	InspectionKind,
	{ icon: ReactNode; iconClass: string; label: string }
>

type InspectionsSummaryCardProps = {
	isLoading: boolean
	kindOrder: InspectionKind[]
	kindConfig: KindConfig
	byKind: Record<
		InspectionKind,
		{ currentMonth: number; previousMonth: number }
	>
	totalDelta: number
}

export function InspectionsSummaryCard({
	isLoading,
	kindOrder,
	kindConfig,
	byKind,
	totalDelta,
}: InspectionsSummaryCardProps) {
	return (
		<Card className="border-kaefer-light-silver px-4 py-5 gap-0 lg:col-span-2">
			<CardHeader className="p-0 flex-row items-center justify-between">
				<CardTitle className="text-sm font-semibold text-kaefer-dark-grey">
					Inspeções por tipo
				</CardTitle>
				{totalDelta !== 0 && (
					<span
						className={cn(
							'flex items-center gap-1 text-xs font-medium',
							totalDelta > 0 ? 'text-kaefer-forest-green' : 'text-kaefer-red',
						)}
					>
						{totalDelta > 0 ? (
							<TrendingUp className="size-3.5" />
						) : (
							<TrendingDown className="size-3.5" />
						)}
						{Math.abs(totalDelta)} vs. mês anterior
					</span>
				)}
			</CardHeader>

			<CardContent className="mt-3 p-0">
				{isLoading ? (
					<p className="text-sm text-muted-foreground">Carregando...</p>
				) : (
					<div className="grid grid-cols-3 gap-2 sm:grid-cols-3 lg:grid-cols-5">
						{kindOrder.map((kind) => {
							const config = kindConfig[kind]
							const data = byKind[kind]
							return (
								<InspectionKpiCard
									key={kind}
									icon={config.icon}
									colorClass={config.iconClass}
									label={config.label}
									value={data.currentMonth}
									previousValue={data.previousMonth}
								/>
							)
						})}
					</div>
				)}
			</CardContent>
		</Card>
	)
}
